import React from 'react';

const UserAboutText = ({ content, userData }) => {
  return (
    <div className="aboutText">
      {/* {content.map((section, index) => ( */}
      <div className="Text border-top py-32">
        <h3 className="font-24 font-m fw-medium text-black pb-16 mb-0">
          {'About Me'}
        </h3>
        {/* {section.paragraphs.map((paragraph, i) => ( */}
        <p>{userData.aboutUsDescription}</p>
        {/* ))} */}
      </div>
      {/* ))} */}
    </div>
  );
};

export default UserAboutText;
